export default class Publications {
  constructor(params) {
    this.params = params;
  }

  latest() {
    this.loadPdf()
  }

  by_date() {
    this.loadPdf()
  }

  loadPdf() {
    $("#pdf_container").flipBook({
      sound: false,
      pdfUrl: $("#pdf_container").data("src"),
      backgroundColor: "rgb(0, 0, 0)",
      btnSound: { enabled: false },
      btnToc: { enabled: false },
      btnBookmark: { enabled: false },
      btnShare: { enabled: false },
      btnPrint: { enabled: false },
      btnDownloadPages: { enabled: false },
      btnDownloadPdf: { enabled: false },
      icons: 'material',
    });
  }
}
